import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import * as R from 'ramda';
import { MainTitle, MenuID, MenuItemType, Module } from 'src/types';
import { BranchConstants } from './index';
export var infoMgmtTabData = [{
  title: '醫令清單',
  id: MenuID.catalog,
  i18n: 'common:menu.catalog',
  module: Module.clinic,
  type: MenuItemType.leavesLevel,
  link: "".concat(MenuID.info_mgmt, "?tab=").concat(MenuID.catalog)
}, {
  title: '常用處方集',
  id: MenuID.corelist,
  i18n: 'common:menu.corelist',
  module: Module.clinic,
  type: MenuItemType.leavesLevel,
  link: "".concat(MenuID.info_mgmt, "?tab=").concat(MenuID.corelist)
}, {
  title: '供應商清單',
  id: MenuID.supplierlist,
  i18n: 'common:menu.supplierlist',
  module: Module.clinic,
  type: MenuItemType.leavesLevel,
  link: "".concat(MenuID.info_mgmt, "?tab=").concat(MenuID.supplierlist)
}];
export var get_MENU_DATA = function get_MENU_DATA() {
  return [{
    title: '診所作業',
    id: MenuID.clinic,
    type: MenuItemType.group,
    subMenus: [{
      title: '預約列表',
      id: MenuID.reservation,
      i18n: 'common:menu.reservation',
      module: Module.clinic,
      type: MenuItemType.leavesLevel,
      link: '/',
      icon: 'checkIn'
    }, {
      title: '看診清單',
      id: MenuID.onboard,
      i18n: 'common:menu.onboard',
      module: Module.clinic,
      type: MenuItemType.leavesLevel,
      icon: 'checkInOnboard'
    }, {
      title: '客戶列表',
      id: MenuID.client_list,
      i18n: 'common:menu.client_list',
      module: Module.clinic,
      type: MenuItemType.leavesLevel,
      icon: 'clientList',
      hide: !BranchConstants.MAIN_MENU_FUNCTIONS.includes(MainTitle.therapy)
    }, {
      title: '藥局出庫',
      id: MenuID.deliverynote,
      i18n: 'common:menu.deliverynote',
      module: Module.clinic,
      type: MenuItemType.leavesLevel,
      icon: 'release-drags',
      hide: !BranchConstants.ENABLE_MODULE_PHARMACY
    }, {
      title: '庫存管理',
      id: MenuID.inventory,
      i18n: 'common:menu.inventory',
      module: Module.clinic,
      type: MenuItemType.withSubMenus,
      icon: 'storage',
      hide: !BranchConstants.ENABLE_MODULE_STOCK,
      subMenus: [{
        title: '庫存公告',
        id: MenuID.stock_news,
        i18n: 'common:menu.stock_news',
        module: Module.clinic,
        type: MenuItemType.leavesLevel
      }, {
        title: '入庫管理',
        id: MenuID.restock_list,
        i18n: 'common:menu.restock_list',
        module: Module.clinic,
        type: MenuItemType.leavesLevel
      }, {
        title: '今日盤點',
        id: MenuID.daily_inventory,
        i18n: 'common:menu.daily_inventory',
        module: Module.clinic,
        type: MenuItemType.leavesLevel
      }]
    }, {
      title: '資料維護',
      id: MenuID.info_mgmt,
      i18n: 'common:menu.info_mgmt',
      icon: 'data',
      module: Module.clinic,
      subMenus: infoMgmtTabData,
      type: MenuItemType.withSubMenus,
      hide: !BranchConstants.ENABLE_MODULE_INFO_MANAGEMENT
    }, {
      title: '量測資料轉移',
      id: MenuID.measurement_mgmt,
      i18n: 'common:menu.measurement_mgmt',
      module: Module.clinic,
      type: MenuItemType.leavesLevel,
      icon: 'dataTransfer',
      hide: !BranchConstants.ENABLE_MODULE_MEASUREMENT_MANAGEMENT
    }]
  }, {
    title: 'Cofit PRO',
    id: MenuID.cofit_pro,
    module: Module.consult,
    type: MenuItemType.group,
    subMenus: [{
      title: 'Cofit PRO',
      id: MenuID.client_mgmt,
      i18n: 'common:menu.client_mgmt',
      link: "".concat(MenuID.client_mgmt, "?clientID=all"),
      module: Module.consult,
      type: MenuItemType.leavesLevel,
      icon: 'cofit',
      hide: !BranchConstants.ENABLE_MODULE_CLIENT_PROFILE
    }, {
      title: '大聊天室',
      id: MenuID.chatroom,
      i18n: 'common:menu.chatroom',
      module: Module.consult,
      type: MenuItemType.leavesLevel,
      icon: 'message',
      isOpenNewWindow: true
    }]
  }, {
    title: '統計報表',
    id: MenuID.statistic,
    type: MenuItemType.group,
    module: Module.clinic,
    hide: !BranchConstants.ENABLE_MODULE_CGREPORT,
    subMenus: [{
      title: '醫療分析',
      i18n: 'common:menu.cg_report',
      id: MenuID.cg_report,
      link: process.env.NEXT_PUBLIC_CG_REPORT_URL,
      icon: 'report',
      type: MenuItemType.externalLink,
      isProtected: true
    }]
  }];
};
export var getModuleFromPathname = function getModuleFromPathname(pathname) {
  var menu = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : get_MENU_DATA();
  var subMenus = R.chain(R.prop('subMenus'), menu);

  if (!(subMenus !== null && subMenus !== void 0 && subMenus.length)) {
    return R.propOr(Module.clinic, 'module', menu);
  }

  var moduleType = R.pipe(R.find(R.propEq(pathname, 'id')), R.propOr(Module.clinic, 'module'))(subMenus);

  if (moduleType) {
    return moduleType;
  }

  return getModuleFromPathname(pathname, subMenus);
};
export var getMainMenu = function getMainMenu(can) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, MainTitle.abdominalUltrasound, {
    title: MainTitle.abdominalUltrasound,
    blocked: !can({
      type: 'action',
      subject: 'abdominal_ultrasound_tab',
      action: 'enter'
    })
  }), _defineProperty(_ref, MainTitle.bloodSugar, {
    title: MainTitle.bloodSugar,
    blocked: !can({
      type: 'action',
      subject: 'blood_sugar_tab',
      action: 'enter'
    })
  }), _defineProperty(_ref, MainTitle.bodyMass, {
    title: MainTitle.bodyMass,
    blocked: !can({
      type: 'action',
      subject: 'body_mass_tab',
      action: 'enter'
    })
  }), _defineProperty(_ref, MainTitle.clientQuestionnaire, {
    title: MainTitle.clientQuestionnaire,
    blocked: !can({
      type: 'action',
      subject: 'client_questionnaire_tab',
      action: 'enter'
    })
  }), _defineProperty(_ref, MainTitle.diagnosis, {
    title: MainTitle.diagnosis,
    blocked: !can({
      type: 'action',
      subject: 'diagnosis_tab',
      action: 'enter'
    })
  }), _defineProperty(_ref, MainTitle.inspectionReport, {
    title: MainTitle.inspectionReport,
    blocked: !can({
      type: 'action',
      subject: 'inspection_report_tab',
      action: 'enter'
    })
  }), _defineProperty(_ref, MainTitle.ordersList, {
    title: MainTitle.ordersList,
    blocked: !can({
      type: 'action',
      subject: 'order_tab',
      action: 'enter'
    })
  }), _defineProperty(_ref, MainTitle.phalanx, {
    title: MainTitle.phalanx,
    blocked: !can({
      type: 'action',
      subject: 'phalanx_tab',
      action: 'enter'
    })
  }), _defineProperty(_ref, MainTitle.report3D, {
    title: MainTitle.report3D,
    blocked: !can({
      type: 'action',
      subject: 'report_3d_tab',
      action: 'enter'
    })
  }), _defineProperty(_ref, MainTitle.therapy, {
    title: MainTitle.therapy,
    blocked: !can({
      type: 'action',
      subject: 'therapy_tab',
      action: 'enter'
    })
  }), _defineProperty(_ref, MainTitle.timeline, {
    title: MainTitle.timeline,
    blocked: !can({
      type: 'action',
      subject: 'timeline_tab',
      action: 'enter'
    })
  }), _defineProperty(_ref, MainTitle.uploadFile, {
    title: MainTitle.uploadFile,
    blocked: !can({
      type: 'action',
      subject: 'upload_file_tab',
      action: 'enter'
    })
  }), _ref;
};